import { MailOpenIcon, PencilAltIcon, PencilIcon, ReplyIcon } from '@heroicons/react/outline'
import React from 'react'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

function ModelTabs({
    actionInitModel,
    oneLinerModel,
    setActionInitModel,
    setOneLinerModel,
    probingModel,
    setProbingModel
}) {

    // console.log(probingModel)

    const handleOutreach = () =>{
        setOneLinerModel(false)
        setActionInitModel(false)
        setProbingModel(false)
    }

    const handleProbing = () =>{
        setProbingModel(true)
        setOneLinerModel(false)
        setActionInitModel(false)
    }

    const handleOneLiner = () =>{
        setOneLinerModel(true)
        setActionInitModel(false)
        setProbingModel(false)
    }

    const handleFollowUp = () =>{
        setOneLinerModel(false)
        setActionInitModel(true)
        setProbingModel(false)
    }

    const tabs = [
        { name: 'Outreach', function: handleOutreach, icon: PencilAltIcon, current: (actionInitModel === false && oneLinerModel === false && probingModel === false) ? true : false },
        { name: 'Opener', function: handleProbing, icon: MailOpenIcon, current: probingModel },
        { name: 'One Liner', function: handleOneLiner, icon: PencilIcon, current: oneLinerModel },
        { name: 'Follow Up', function: handleFollowUp, icon: ReplyIcon, current: actionInitModel },
      ]

    return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
        //   defaultValue={tabs.find((tab) => tab?.current).name}
        >
          {tabs.map((tab) => (
            <option key={tab?.name}>{tab?.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <div className="flex justify-center" aria-label="Tabs">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                onClick={tab.function}
                className={classNames(
                  tab.current
                    ? 'border-indigo-500 text-indigo-600 border-b-4 rounded-lg shadow-lg'
                    : 'border-transparent text-gray-500 hover:text-indigo-600 hover:border-gray-300',
                  'group inline-flex cursor-pointer items-center justify-center py-4 px-1 font-medium text-sm shadow-sm -mb-0.5 w-1/3 border-gray-400'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                <tab.icon
                  className={classNames(
                    tab.current ? 'text-indigo-500' : 'text-gray-400 group-hover:text-indigo-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
                <span>{tab.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    )
}

export default ModelTabs
